import { render } from "./ReturnListItem.vue?vue&type=template&id=064260d7&ts=true"
import script from "./ReturnListItem.vue?vue&type=script&lang=ts"
export * from "./ReturnListItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__